import { defineStore } from 'pinia';
import { OrganizationDetails, UserData } from '@/components/backend';

/**
 * this is where the users will be stores, to be accessible to the user-search components
 */
const useUserStore = defineStore('user', {
  state: () => ({
    users: [] as UserData[],
    organizations: [] as OrganizationDetails[],
    exportActive: false,
  }),

  // getters: {
  //     getSelectedUser: (state) => state.users[state.selectedUser],
  //     isUserSelected: (state) => state.selectedUser >= 0,
  // },

  actions: {
    getOrganization(id: string): OrganizationDetails | undefined {
      return this.organizations.find((x) => x.id === id);
    },
  },
});

export default useUserStore;
